import { CardInputWithType, ECardType } from '__generated__/globalTypes';
import { CreateGuideStoryVariables } from 'graphql/mutation/__generated__/CreateGuideStory';
import { GuideQuery_guide_stories } from 'graphql/query/__generated__/GuideQuery';

const IMPORT_KEY_COL = 'Název společnosti';

// TODO:
// miesta pôsobenia firmy a kontakt na firmu.

/*
FIELDS
"Název společnosti" ✅
"Logo" 
"Kreativní strana" 🔴
"Kategorie oboru" ✅
"Možnosti pro studenty"
"Kontakt" 🔴
"Kde působíte/adresa"
"Základní informace o společnosti" ✅
"Nabízíme, výhody, benefity" ✅
"Hledáme" ✅
"Požadavky na uchazeče" ✅
*/

const CATEGORIES = {
    Chemie: '0634693a-beb2-4f6c-9886-a694b7d56f08',
    'Chemické technologie': 'b19f9859-de48-449d-bc4b-07898606efaf',
    'Technologie materiálů': '7362049a-9fc4-479f-add0-78adf11a6b97',
    'Analytická a forenzní chemie': 'd3fa6ba9-87c8-428a-aa1b-3762c7500299',
    'Chemické inženýrství a bioinženýrství': '5ee5d9dc-95ad-4325-a950-6084d402053a',
    'Životní prostředí a voda': '5c3d963e-418e-4ea2-9d9b-ee0c28c5e928',
    'Energie a paliva': '92e13f99-91d5-44ce-b45d-fd7185616d29',
    'Environmentální analýza': '03e6909b-5eaa-457c-8341-a1ef6dd11934',
    'Technologie potravin': '84545f47-97cf-4151-b3ac-e205ecf77cd0',
    'Biochemie a biotechnologie': '62dd0a89-b4c7-4b2c-8dda-bbaec286dbdc',
    'Informatika a datové inženýrství': 'e0afc729-bc00-4f5a-8476-91ab41d1afb6',
    'Ekonomika a management': '14d1eb28-8147-476c-8fba-ff47105d8aac',
    'Mezinárodní obchod': 'c036aafb-3065-4fbc-a512-a5e8f1ff5eda'
};

function parser(guideId: string, row: Record<string, string>): CreateGuideStoryVariables {
    // const regex = new RegExp(`file/d/(.*?)/view`);
    const imageId = row['Logo']
        .replace('https://drive.google.com/open?id=', '')
        .replace('&usp=drive_copy', '')
        .trim();
    // const match = regex.exec(row['Logo']);
    const imageUrl = 'https://drive.google.com/uc?id=' + imageId;

    const mutationPayload: CreateGuideStoryVariables = {
        guideId,
        story: {
            importKey: row[IMPORT_KEY_COL],
            header: {
                title: row['Název společnosti'],
                text: row['Základní informace o společnosti'],
                imageUrl
                // imageStyleId: 'stretch'
            }
        },
        cards: []
    };

    const moznostiProStudentyCardExists = row['Možnosti pro studenty'];
    const moznostiProStudentyCard: CardInputWithType = {
        type: ECardType.TEXT,
        info: {
            title: 'Možnosti pro studenty',
            description: row['Možnosti pro studenty']
        }
    };

    const nabizimeCardExists = row['Nabízíme, výhody, benefity'];
    const nabizimeCard: CardInputWithType = {
        type: ECardType.TEXT,
        info: {
            title: 'Nabízíme, výhody, benefity',
            description: row['Nabízíme, výhody, benefity']
        }
    };

    const hledameCardExists = row['Hledáme'];
    const hledameCard: CardInputWithType = {
        type: ECardType.TEXT,
        info: {
            title: 'Hledáme',
            description: row['Hledáme']
        }
    };

    const pozadavkyCardExists = row['Požadavky na uchazeče'];
    const pozadavkyCard: CardInputWithType = {
        type: ECardType.TEXT,
        info: {
            title: 'Požadavky na uchazeče',
            description: row['Požadavky na uchazeče']
        }
    };

    const pozadavkyHledameCardExists = row['Požadavky, hledáme'];
    const pozadavkyHledameCard: CardInputWithType = {
        type: ECardType.TEXT,
        info: {
            title: 'Požadavky, hledáme',
            description: row['Požadavky, hledáme']
        }
    };

    const kontaktCardExists = row['Kontakt'];
    const kontaktCard: CardInputWithType = {
        type: ECardType.TEXT,
        info: {
            title: 'Kontakt',
            description: row['Kontakt']
        }
    };

    const addressCardExists = row['Kde působíte/adresa'];
    const addressCard: CardInputWithType = {
        type: ECardType.TEXT,
        info: {
            title: 'Místo působení/adresa',
            description: row['Kde působíte/adresa']
        }
    };

    // Kde působíte/adresa

    if (moznostiProStudentyCardExists) {
        mutationPayload.cards.push(moznostiProStudentyCard);
    }
    if (nabizimeCardExists) {
        mutationPayload.cards.push(nabizimeCard);
    }
    if (hledameCardExists) {
        mutationPayload.cards.push(hledameCard);
    }
    if (pozadavkyCardExists) {
        mutationPayload.cards.push(pozadavkyCard);
    }
    if (pozadavkyHledameCardExists) {
        mutationPayload.cards.push(pozadavkyHledameCard);
    }
    if (addressCardExists) {
        mutationPayload.cards.push(addressCard);
    }
    if (kontaktCardExists) {
        mutationPayload.cards.push(kontaktCard);
    }

    const categoryIds: string[] = row['Kategorie oboru']
        .split(',')
        .filter((e) => e.trim())
        .map((categoryName) => categoryName.trim())
        .map((categoryName) => CATEGORIES[categoryName]);

    mutationPayload.addToCategoriesId = categoryIds;

    return mutationPayload;
}

function duplicateChecker(story: GuideQuery_guide_stories, row: Record<string, string>): boolean {
    return story.importKey?.toLowerCase() === row[IMPORT_KEY_COL]?.toLowerCase();
}

export const vschtImportMethods = { duplicateChecker, parser };
